<template>
  <v-card class="pl-5 pr-5">
    <h1>Institution Collections</h1>
    <v-divider></v-divider>
    <Notification :notify="notify" />
    <UploadingStatus ref="uploadingStatus" />
     <ConfirmationDialog ref="confirm" />
    <div class="row" v-show="!isEdit">
      <div class="pl-3 col">
        <v-text-field
          id="search"
          v-model="Search"
          label="Search"
          required
          append-outer-icon="mdi-table-search"
          @click:append-outer="onSearch"
          v-on:keyup.enter="onSearch()"
        ></v-text-field>
      </div>
      <div class="col" v-if="isEdit == false">
        <div class="float-right">
          <v-btn color="primary" @click="onNew" class="mt-4" id="btnNew">
            New Collection
          </v-btn>
        </div>
      </div>
    </div>
    <div v-if="isEdit == true">
      <div class="row">
        <div class="col">
          <v-text-field
            id="CollectionName"
            label="Collection Name*"
            required
            v-model="selectedObj.Name"
          ></v-text-field>
        </div>
        <div class="col">
          <v-text-field
            id="Description"
            label="Collection Description"
            v-model="selectedObj.Description"
          ></v-text-field>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="row">
            <div class="col">
              <v-radio-group v-model="selectAllRecords" column @change="onSelectAll" id="SelectAllDeSelect">
                <v-radio label="Select All" value="true" id="selectAll"></v-radio>
                <v-radio label="De Select All" value="false" id="DeSelectAll"></v-radio>
              </v-radio-group>
            </div>
            <!-- <div class="col">
              <v-checkbox
                v-model="selectedObj.isSelectAll"
                label="Select All"
                @change="onSelectAll"
              ></v-checkbox>
            </div>
            <div class="col">
              <v-checkbox
                v-model="selectedObj.isDeSelectAll"
                label="De Select All"
                @change="onDeSelectAll"
              ></v-checkbox>
            </div> -->
          </div>
        </div>
        <div class="col-6 text-right">
          <div class="row">
            <div class="col">
              <v-btn
                id="downloadpublication"
                color="primary"
                @click="onDownloadPublications(0)"
                class="mt-4"
              >
                <v-icon left>mdi-file-delimited-outline</v-icon>Download Publications</v-btn
              >
            </div>
            <div class="col">
              <v-file-input
                ref="dataUpload"
                id="dataUpload"
                accept=".csv"
                placeholder="Upload a csv file"
                prepend-icon="mdi-file-excel"
                label="Data Upload"
                @change="onDataUpload"
              ></v-file-input>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <v-card>
            <div class="row">
              <div class="col-5 ml-5">
                <v-text-field
                  id="search"
                  label="Search"
                  v-model="SearchPublication"
                  append-outer-icon="mdi-table-search"
                  @click:append-outer="onSearchPublications"
                  v-on:keyup.enter="onSearchPublications"
                ></v-text-field>
              </div>
              <div class="col-6"></div>
            </div>
            <v-divider></v-divider>
            <div style="height: 600px; overflow-y: scroll">
              <v-data-table
                :headers="publicationHeader"
                :items="publications"
                item-key="id"
                hide-default-footer
                :items-per-page="publications.length"
              >
                <template v-slot:item.id="{ item }">
                  <v-simple-checkbox
                    id="Selected"
                    v-model="item.IsSelected"
                    @click="onSelect(item)"
                    :disabled="item.disabled"
                  ></v-simple-checkbox>
                </template>
              </v-data-table>
              <Pagination :paging="paging" v-on:next="onPublicationNextPage" />
            </div>
          </v-card>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="float-right">
            <v-btn @click="onCancel()" id="btnCancel"> Cancel </v-btn>
            <v-btn
              id="btnSave"
              class="mr-4"
              color="primary"
              @click="onSave()"
              :loading="loading"
              :disabled="loading"
            >
              Save
            </v-btn>
          </div>
        </div>
      </div>
    </div>
    <!-- Publications Collections -->
    <div class="row" v-if="isEdit == false">
      <div class="col">
        <v-data-table
          :headers="organizationHeader"
          :items="organizationCollections"
          hide-default-footer
        >
          <template v-slot:item.id="{ item }">
            <v-icon class="mr-2 icon-edit" @click="onEdit(item)"
              >mdi-comment-edit</v-icon
            >
            <v-icon class="mr-2 icon-delete" @click="onDelete(item)"
              >mdi-delete</v-icon
            >
          </template>
        </v-data-table>
      </div>
    </div>
    <div class="row" v-if="isEdit == false">
      <div class="col">
        <Pagination :paging="paging_orgCollection" v-on:next="onNextPage" />
      </div>
    </div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-card>
</template>

<script>
import lodash from "lodash";
import Notification from "@/components/Notification";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import Pagination from "@/components/Pagination";
import PublicationCollections from "@/components/PublicationCollections";
import csv from 'csvtojson';
import { Parser } from "json2csv";
import fileUploadService from "../../api/fileUploadService";
import * as api from "@/api";
import UploadingStatus from "@/components/UploadingStatus.vue";

export default {
  components: {
    Pagination,
    Notification,
    ConfirmationDialog,
    UploadingStatus
  },
  data() {
    return {
      isEdit: false,
      Search: "",
      SearchPublication: "",
      selectedObj: {},
      paging_orgCollection: { count: 20, page: 1, size: 20, keyword: "" },
      paging_publications: { count: 20, page: 1, size: 20, keyword: "" },
      paging: { count: 20, page: 1, size: 20, keyword: "" },
      organizationHeader: [
        {
          text: "Name",
          align: "start",
          sortable: false,
          value: "Name"
        },
        {
          text: "Description",
          align: "start",
          sortable: false,
          value: "Description"
        },
        {
          text: "",
          align: "start",
          sortable: false,
          value: "id"
        }
      ],
      publicationHeader: [
        {
          text: "",
          align: "start",
          sortable: false,
          value: "id"
        },
        {
          text: "Name",
          align: "start",
          sortable: false,
          value: "Title"
        },
        {
          text: "ISBN",
          align: "start",
          sortable: false,
          value: "ISBN"
        },
        {
          text: "Contributor",
          align: "start",
          sortable: false,
          value: "Contributor1"
        },
        {
          text: "Publisher",
          align: "start",
          sortable: false,
          value: "PublisherName"
        }
      ],
      publications: [],
      organizationCollections: [],
      notify: {
        type: 0,
        message: "",
        errors: []
      },
      overlay: false,
      selectedPublicationIds: [],
      loading: false,
      selectAllRecords:false,
      disableTable: false,
      disablePage : false
    };
  },
  methods: {
    onSearch() {
      this.paging_orgCollection.page = 1;
      this.paging_orgCollection.keyword = this.Search;
      this.getOrgCollectionByPagin();
    },
    onNextPage(page) {
      console.log("onNextPage " + page);
      this.paging_orgCollection.page = page;
      this.paging_orgCollection.keyword = this.Search;
      console.log(this.paging_orgCollection);

      this.getOrgCollectionByPagin();
    },
    onPublicationNextPage(page) {
      console.log("onNextPage pub" + page);
      this.paging.page = page;
      this.paging.keyword = this.SearchPublication;
      this.getPublications(this.selectedObj.id);
    },
    getOrgCollectionByPagin() {
      let that = this;
      that.overlay = true;
      that.organizationCollections.splice(
        0,
        that.organizationCollections.length
      );
      new Promise((resolve, reject) => {
        api
          .getByPagin("organization-collection", this.paging_orgCollection)
          .then(response => {
            this.paging_orgCollection.count = response.data.count;
            for (let i = 0; i < response.data.data.length; i++) {
              that.organizationCollections.push(response.data.data[i]);
            }
            console.log(that.organizationCollections);

            that.overlay = false;
          })
          .catch(error => {
            reject(error);
            that.overlay = false;
          });
      });
    },
    getOrgCollectionDetail(id) {
      let that = this;
      new Promise((resolve, reject) => {
        api
          .getByID("organization-collection", id)
          .then(response => {})
          .catch(error => {
            reject(error);
          });
      });
    },
    getPublications(id) {
      let that = this;
      this.paging.keyword = this.SearchPublication;

      //debugger;

      that.publications.splice(0, that.publications.length);
      new Promise((resolve, reject) => {
        api
          .getByPaginById(
            "organization-collection/publication",
            id,
            this.paging
          )
          .then(response => {
            that.publications = [];
            this.paging.count = response.data.count;
            for (let i = 0; i < response.data.data.length; i++) {
              that.publications.push({
                id: response.data.data[i].id,
                Title: response.data.data[i].Title,
                ISBN: response.data.data[i].ISBN,
                PublisherName: response.data.data[i].PublisherName,
                Contributor1: response.data.data[i].Contributor1,
                IsSelected: response.data.data[i].IsSelected
              });
            }
            this.verifySelectedItems();
          })
          .catch(error => {
            reject(error);
          }).finally(() => {
            if(this.selectAllRecords){
              this.onSelectAll();
            }
          });
      });
    },
    onNew() {
      let that = this;
      this.selectedObj.id = 0;
      this.selectedObj.Name = "";
      this.selectedObj.Description = "";
      this.selectedObj.isCoreCollection = false;
      this.selectedObj.isSelectAll = false;
      this.selectedObj.isDeSelectAll = false;
      this.selectedObj.collectionType = 1;
      this.isEdit = true;
      /*
      if (this.publications != null && this.publications.length > 0) {
        that.publications.forEach(e => {
          e.IsSelected = false;
        });
      }
      */
      this.selectedPublicationIds = [];
      this.paging.count = 1;
      this.getPublications(0);
    },
    onEdit(item) {
      this.isEdit = true;
      this.selectedObj = Object.assign({}, item);
      this.selectedObj.publications = [];
      this.selectedPublicationIds = [];

      new Promise((resolve, reject) => {
        api
          .getByPaginById(
            "organization-collection/publication",
            item.id,
            { count: 10000000, page: 1, size: 10000000, keyword: "" }
          )
          .then(response => {
            this.paging.count = response.data.count;
            for (let i = 0; i < response.data.data.length; i++) {
              if (response.data.data[i].IsSelected) {
                this.selectedPublicationIds.push({ id: response.data.data[i].id });
              }
            }
            return response.data;
          })
          .then(data => {
            this.getPublications(item.id);
          })
          .catch(error => {
            reject(error);
          })
           .finally(() => {
            console.log("Selected Publication IDs in Edit: " + this.selectedPublicationIds);
          });
      });

      console.log(this.selectedObj);

      

      // for (let i = 0; i < this.selectedObj.publications.length; i++) {
      //   this.selectedPublicationIds.push(this.selectedObj.publications[i]
      //     //JSON.parse(this.selectedObj.publications[i])
      //   );
      // }

      

      console.log("Selected Publication IDs: " + this.selectedPublicationIds)

     
    },
    async onDelete(item) {
      let that = this;
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure, Do you really want to delete this record?"
        )
      ) {
        new Promise((resolve, reject) => {
          api
            .DeleteByID("organization-collection", item.id)
            .then(response => {
              resolve(response);
              if (response.status === 200 || response.status === 201) {
                this.notify.type = 1;
                this.notify.message = "Record successfully deleted";
                this.getOrgCollectionByPagin();
                setTimeout(() => {
                  this.notify.type = 0;
                }, 3000);
              } else {
                this.notify.type = 4;
                this.notify.errors.push("Failed to save data.");
              }
            })
            .catch(error => {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data. " + error);
              reject(error);
            });
        });
      }
    },
    onCancel() {
      this.isEdit = false;
    },
    onSave() {
      console.log(this.selectedObj);
      this.notify.type = 0;
      this.notify.errors = [];

      this.selectedObj.collectionType = 1;

      console.log("Selected Publications to Save");
      this.selectedObj.publications = this.selectedPublicationIds;

      if (this.selectedObj.Name == "") {
        this.notify.type = 4;
        this.notify.errors.push("Please enter Collection name.");
        return;
      }

      if (this.selectedObj.isSelectAll || this.selectedObj.isDeSelectAll) {
        if (this.selectedObj.isSelectAll && this.selectedObj.isDeSelectAll) {
          this.notify.type = 4;
          this.notify.errors.push(
            "Please check 'Select All' or 'De Select All'"
          );
          return;
        }
      } else {
        if (this.selectedObj.publications.length == 0) {
          this.notify.type = 4;
          this.notify.errors.push("Please select at least one publication.");
          return;
        }
      }

      this.loading = true;
      new Promise((resolve, reject) => {
        api
          .update("organization-collection", this.selectedObj)
          .then(response => {
            resolve(response);
            if (response.status === 200 || response.status === 201) {
              this.notify.type = 1;
              this.notify.message =
                this.selectedObj.id === -1
                  ? "Record successfully saved."
                  : "Record successfully updated.";
              this.loading = false;
              this.isEdit = false;
              this.selectAllRecords = false;
              this.getOrgCollectionByPagin();
              setTimeout(() => {
                this.notify.type = 0;
              }, 3000);
            } else {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data.");
              this.loading = false;
            }
          })
          .catch(error => {
            if (error.message == "Request failed with status code 409") {
              this.notify.type = 4;
              this.notify.errors.push("Collection name already exist");
              this.loading = false;
              reject(error);
            } else {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data. " + error);
              this.loading = false;
            }
          });
      });
    },
    onSearchPublications() {
      this.paging.keyword = this.SearchPublication;
      this.paging.page = 1;
      this.getPublications(this.selectedObj.id);
    },
    onSelect(item) {
      debugger
      var found = this.selectedPublicationIds.filter(p => p.id == item.id);
      console.log(" found " + found.found);

      console.log(item)

      if (found == undefined || found.length == 0 && item.IsSelected == true)
        this.selectedPublicationIds.push({ id: item.id });
      else {

        for (var i = 0; i < this.selectedPublicationIds.length; i++) {
          if (this.selectedPublicationIds[i].id === item.id && item.IsSelected == false) {
            this.selectedPublicationIds.splice(i, 1);
            break;
          }
        }
      }

      console.log(this.selectedPublicationIds);
    },
    verifySelectedItems() {
      this.publications.forEach(element => {
        var found = this.selectedPublicationIds.filter(p => p.id == element.id);
        if (found != undefined && found.length > 0) {
          element.IsSelected = true;
          element.disabled = false;
        } else {
          element.IsSelected = false;
          element.disabled = false;
        }
      });
    },
    onSelectAll() {
      if(this.selectAllRecords == "false") {
        this.selectedObj.isSelectAll = false;
        this.selectedObj.isDeSelectAll = true;
        if(this.publications && this.publications.length > 0) {
          this.publications.forEach(e=> {
            e.IsSelected = false;
            e.disabled = false;
          });
        }
      }else {
        this.selectedObj.isSelectAll = true;
        this.selectedObj.isDeSelectAll = false;
        if(this.publications && this.publications.length > 0) {
          this.publications.forEach(e=> {
            e.IsSelected = true;
            e.disabled = true;
          });
        }
      }
    },
    onDownloadPublications(id) {
      api.getAll("organization-collection/publication/all/" + id).then((response) => {
        this.exportData = response.data;
        this.downloadPublicationMetadataAsCSV(this.exportData);
      });
    },
    downloadPublicationMetadataAsCSV(json) {
      const parser = new Parser();
      const csv = parser.parse(
        json.map((pub) => this.mapPublicationMetadataToCSVRecord(pub))
      );

      var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

      var link = document.createElement("a");
      var url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "publications-metadata.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    mapPublicationMetadataToCSVRecord(pub) {
      return {
        id: pub.id || "",
        Title: pub.Title || "",
        ISBN: pub.ISBN || "",
        "Publisher Name": pub.PublisherName || "",
        "Include in Collection": false,
      };
    },
    async onDataUpload(file) {
      if (this._uploading) return;
      this._uploading = true;

      this.overlay = true;
      
      if (!file) {
        this.overlay = false;
        this._uploading = false;
        return;
      }

      const confirmed = await this.$refs.confirm.open(
        "Confirm",
        "Are you sure you want to upload this file?"
      );

      if (!confirmed) {
        this.overlay = false;
        const input = this.$refs.dataUpload.$el.querySelector('input');
        if (input) input.value = null;
        this.$refs.dataUpload.reset();
        this._uploading = false;
        return;
      }

      try {
        const content = await fileUploadService.uploadFileReader(file);
        const uploadContent = await this.CsvToJson(content);
        const payloadContent = [];
        const validations = [];

        for (const item of uploadContent) {

            let isValid = true;
            const includeInCollection = item["Include in Collection"].toLocaleLowerCase() === 'true' ? true : item["Include in Collection"].toLocaleLowerCase() === 'false' ? false : item["Include in Collection"];
            if (!this.isColumnNotEmpty(includeInCollection)) {
              validations.push({Title: item.Title, ISBN: item.ISBN, PublisherName: item["Publisher Name"], Message: `"Include in Collection" column should be a True or False`, isSuccess: false  });
              isValid = false;
            }
            if (isValid && includeInCollection === true) {
              payloadContent.push({
                id: Number(item.id) || "",
                Title: item.Title || "",
                ISBN: item.ISBN || "",
                PublisherName: item["Publisher Name"] || "",
                IsSelected: true,
              });
              validations.push({Title: item.Title, ISBN: item.ISBN, PublisherName: item["Publisher Name"], Message: `Added to Collection`, isSuccess: true  });
            } else if (isValid && includeInCollection === false) {
              payloadContent.push({
                id: Number(item.id) || "",
                Title: item.Title || "",
                ISBN: item.ISBN || "",
                PublisherName: item["Publisher Name"] || "",
                IsSelected: false,
              });
              validations.push({Title: item.Title, ISBN: item.ISBN, PublisherName: item["Publisher Name"], Message: `Not added to Collection`, isSuccess: true  });
            }
        }

        this.loading = true;
        if (payloadContent.length > 0) {
          for (const payloadItem of payloadContent) {
            this.onSelect(payloadItem);
          }
          this.verifySelectedItems();
          this.$refs.uploadingStatus.open(validations);
        } else {
          this.$refs.uploadingStatus.open(validations);
        }
      } catch (error) {
        this.notify.type = 4;
        this.notify.errors.push("Failed to upload data. " + error);
      } finally {
        this.loading = false;
        this.overlay = false;
        const input = this.$refs.dataUpload.$el.querySelector('input');
        if (input) input.value = null;
        this.$refs.dataUpload.reset();
        this._uploading = false;
      }
    },
    async CsvToJson(content) {
      return new Promise((resolve,reject)=> {
        csv({
            noheader:false,
            output: "json",
            quote: '"',
            flatKeys: false,
            downstreamFormat: true
        }).fromString(content)
        .then((csvRow)=>{ 
            resolve(csvRow);
        })
      });    
    },
    isColumnNotEmpty(value) {
      if (typeof value !== 'boolean') {
        return false;
      }
      return true;
    },
  },
  created() {
    this.getOrgCollectionByPagin();
  },
  mounted() {}
};
</script>



// WEBPACK FOOTER //
// src/views/Organization/OrgCollectionNew.vue